import { REVIEW_REQUIREMENTS, findingValue, valueLabel } from "../lib/reviewRequirements.js";
import HoverTooltip from "./HoverTooltip.jsx";
import "./FindingCharacteristics.css";

const axisFields = { reason: "reason", severity: "effective_severity", sensitivity: "content_sensitivity", policy: "policy_status", norms: "norm_status", intent: "intent_status", evidence: "evidence_status", verifier: "verifier_status", policyClaim: "policy_claim_result", intentClaim: "intent_claim_result" };
function characteristicHelp(definition) {
    // The severity row reports the behaviour axis on its own, so it does not
    // borrow the combined-severity wording the definition carries.
    return definition.field === "effective_severity"
        ? "The behaviour severity recorded by the review. Content sensitivity is listed separately."
        : definition.help;
}
export function ReviewCharacteristicHelp({ axis }) {
    const definition = REVIEW_REQUIREMENTS.find((item) => item.field === axisFields[axis]);
    if (!definition) return null;
    return <HoverTooltip wide label={characteristicHelp(definition)}><button className="review-characteristic-help" type="button" aria-label={`About ${definition.label.toLowerCase()}`}>?</button></HoverTooltip>;
}

export default function FindingCharacteristics({ finding }) {
    const normalized = { ...finding };
    for (const [key, value] of Object.entries(finding)) {
        const camel = key.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
        if (normalized[camel] == null) normalized[camel] = value;
    }
    normalized.policyStatus ??= finding.policy?.status;
    normalized.normStatus ??= finding.norms?.status;
    normalized.intentStatus ??= finding.intent?.status;
    normalized.policyClaimResult ??= finding.policy?.claim?.result;
    normalized.intentClaimResult ??= finding.intent?.claim?.result;
    return <details className="finding-characteristics">
        <summary>Review characteristics</summary>
        <div className="finding-characteristics-body">
            <p>These assessments describe why the review generated this finding.</p>
            <dl>{REVIEW_REQUIREMENTS.map((definition) => {
                const severity = definition.field === "effective_severity";
                const label = severity ? "Behaviour severity" : definition.label;
                const help = characteristicHelp(definition);
                const value = severity ? normalized.behaviourSeverity ?? normalized.severity : findingValue(definition, normalized);
                return <div key={definition.id}>
                    <dt>{label} <HoverTooltip wide label={help}><button type="button" aria-label={`About ${label.toLowerCase()}`}>?</button></HoverTooltip></dt>
                    <dd>{value ? valueLabel(value) : "Not recorded"}</dd>
                </div>;
            })}</dl>
            <p>Not recorded means no assessment was published. No view is an explicit assessment. Indeterminate is an unresolved claim check; verifier status records whether the check ran.</p>
        </div>
    </details>;
}
